module.exports = __webpack_public_path__ + "static/lovie_logo-fcc255503aaa2f80e5b9feabd261911a.png";